<script setup lang="ts">
  defineOptions({ inheritAttrs: false });

  defineProps<{
    id: string;
    checked: boolean;
    value?: string;
    indeterminate?: boolean;
  }>();

  defineEmits<{ (e: 'change', event: Event): void }>();
</script>

<template>
  <div class="relative inline-flex items-center justify-center flex-shrink-0">
    <input
      :id="id"
      type="checkbox"
      :value="value"
      :checked="checked"
      :indeterminate="indeterminate && !checked"
      :disabled="!!$attrs.disabled"
      class="w-4 h-4 rounded appearance-none bg-white-01 border border-[var(--color-light-gray-xx)] checked:bg-[var(--theme-secondary)] checked:border-[var(--theme-secondary-ink)] indeterminate:bg-[var(--theme-secondary)] indeterminate:border-[var(--theme-secondary-ink)] cursor-pointer disabled:bg-[var(--color-gray-06)] disabled:border-gray-06 disabled:cursor-not-allowed"
      v-bind="$attrs"
      @change="$emit('change', $event)"
    >
    <span
      v-if="checked"
      class="absolute inset-0 flex items-center justify-center pointer-events-none"
    >
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 1L3.5 6.5L1 4"
          stroke="white"
          stroke-width="1.6666"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span
      v-else-if="indeterminate"
      class="absolute inset-0 flex items-center justify-center pointer-events-none"
      data-testid="custom-checkbox-indeterminate-mark"
    >
      <span class="h-0.5 w-2 rounded-full bg-[var(--color-white)]" />
    </span>
  </div>
</template>
